<!-- Tutto quello che é in javascript:void(0) va cambiato con gli url del comune se non vi é servizio di recupero header e footer -->
<footer class="it-footer" id="footer">
  <div class="it-footer-main">
    <div class="container">
      <div class="row">
        <div class="col-12 footer-items-wrapper logo-wrapper">
          <img width="178" height="56" class="ue-logo cwvlazyload" alt="logo Unione Europea"
               [src]="homePageHeaderFooter ? homePageHeaderFooter.Footer.Municipality.EuLogo : 'content/images/footer/logo-eu-footer.svg'">
          <div class="it-brand-wrapper">
            <a (click)="goToHome()" class="text-decoration-none" data-focus-mouse="false">
              <img class="icon" [src]="getImage()" width="82" height="82" />
              <div class="it-brand-text">
                <h2 class="no_toc" *ngIf="!homePageHeaderFooter">Comune di <span>{{ configurazione ? configurazione.nome : '' }}</span></h2>
                <h2 class="no_toc" *ngIf="homePageHeaderFooter">{{homePageHeaderFooter.Footer.Contacts.City}}</h2>

              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 footer-items-wrapper">
          <h3 class="footer-heading-title">
            <span *ngIf="!homePageHeaderFooter">Amministrazione</span><span *ngIf="homePageHeaderFooter"><a [title]="'Vai alla pagina: Amministrazione'" class="text-decoration-none" [attr.href]="homePageHeaderFooter.BaseURLSito + '/' + homePageHeaderFooter.Footer.AmministrationLink">Amministrazione</a></span>
          </h3>
          <div class="menu-amministrazione-container">
            <ul id="menu-amministrazione" class="footer-list" *ngIf="!homePageHeaderFooter">
              <li><a [href]="configurazione.baseUrl + '/amministrazione/organi-di-governo'">Organi di governo</a></li>
              <li><a [href]="configurazione.baseUrl + '/amministrazione/aree-amministrative'">Aree amministrative</a></li>
              <li><a [href]="configurazione.baseUrl + '/amministrazione/uffici'">Uffici</a></li>
              <li><a [href]="configurazione.baseUrl + '/amministrazione/enti-e-fondazioni'">Enti e fondazioni</a></li>
              <li><a [href]="configurazione.baseUrl + '/amministrazione/politici'">Politici</a></li>
              <li><a [href]="configurazione.baseUrl + '/amministrazione/personale-amministrativo'">Personale amministrativo</a></li>
              <li><a [href]="configurazione.baseUrl + '/amministrazione/documenti-e-dati'">Documenti e dati</a></li>
            </ul>
            <ul id="menu-amministrazione-api" class="footer-list" *ngIf="homePageHeaderFooter">
              <li *ngFor="let linkAmm of homePageHeaderFooter.Footer.Amministration">
                <a [title]="'Vai alla pagina: ' + linkAmm.Label" [attr.href]="linkAmm.External ? linkAmm.Link :  homePageHeaderFooter.BaseURLSito + '/' + linkAmm.Link"
                   [attr.data-element]="linkAmm.DataElement">{{linkAmm.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="linkAmm.External && !linkAmm.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 footer-items-wrapper">
          <h3 class="footer-heading-title">
            <span *ngIf="!homePageHeaderFooter">Categorie di servizio</span><span *ngIf="homePageHeaderFooter"><a [title]="'Vai alla pagina: Servizi'" class="text-decoration-none" [attr.href]="homePageHeaderFooter.BaseURLSito + '/' + homePageHeaderFooter.Footer.CategoryServicesLink">Categorie di servizio</a></span>
          </h3>
          <div class="row" *ngIf="!homePageHeaderFooter">
            <div class="col-md-6">
              <div class="menu-categorie-di-servizio-container">
                <ul id="menu-categorie-di-servizio" class="footer-list">
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/agricoltura-e-pesca'">Agricoltura e pesca</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/ambiente/'">Ambiente</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/anagrafe-e-stato-civile/'">Anagrafe e stato civile</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/appalti-pubblici/'">Appalti pubblici</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/autorizzazioni/'">Autorizzazioni</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/catasto-e-urbanistica/'">Catasto e urbanistica</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/cultura-e-tempo-libero/'">Cultura e tempo libero</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/educazione-e-formazione/'">Educazione e formazione</a></li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="menu-categorie-di-servizio-container">
                <ul id="menu-categorie-di-servizio-1" class="footer-list">
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/giustizia-e-sicurezza-pubblica/'">Giustizia e sicurezza pubblica</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/imprese-e-commercio/'">Imprese e commercio</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/mobilita-e-trasporti/'">Mobilità e trasporti</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/salute-benessere-e-assistenza/'">Salute, benessere e assistenza</a></li>
                  <li><a [href]="configurazione.baseUrl + '/tributi-finanze-e-contravvenzioni/'">Tributi, finanze e contravvenzioni</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/turismo/'">Turismo</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi-categoria/vita-lavorativa/'">Vita lavorativa</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="homePageHeaderFooter">
            <div class="col-md-12">
              <div class="menu-categorie-di-servizio-container">
                <ul id="menu-categorie-di-servizio-api" class="footer-list">
                  <li *ngFor="let catServiceLink of homePageHeaderFooter.Footer.CategoryServices"><a [title]="'Vai alla pagina: ' + catServiceLink.Label" [attr.href]="catServiceLink.External ? catServiceLink.Link :  homePageHeaderFooter.BaseURLSito + '/' + catServiceLink.Link"
                         [attr.data-element]="catServiceLink.DataElement">{{catServiceLink.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="catServiceLink.External && !catServiceLink.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 footer-items-wrapper">
          <h3 class="footer-heading-title">
            <span [title]="'Vai alla pagina: Novità'" *ngIf="!homePageHeaderFooter">Novità</span><span *ngIf="homePageHeaderFooter"><a class="text-decoration-none" [title]="'Vai alla pagina: Novità'"  [attr.href]="homePageHeaderFooter.BaseURLSito + '/' + homePageHeaderFooter.Footer.NewsLink">Novità</a></span>
          </h3>
          <div class="footer-list">
            <ul id="menu-novita" class="footer-list" *ngIf="!homePageHeaderFooter">
              <li><a [href]="configurazione.baseUrl + '/novita/notizie/'">Notizie</a></li>
              <li><a [href]="configurazione.baseUrl + '/novita/comunicati/'">Comunicati</a></li>
              <li><a [href]="configurazione.baseUrl + '/novita/avvisi/'">Avvisi</a></li>
            </ul>
            <ul id="menu-novita-api" class="footer-list" *ngIf="homePageHeaderFooter">
              <li *ngFor="let newsLink of homePageHeaderFooter.Footer.News"><a [title]="'Vai alla pagina: ' + newsLink.Label" [attr.href]="newsLink.External ? newsLink.Link :  homePageHeaderFooter.BaseURLSito + '/' + newsLink.Link"
                                                                               [attr.data-element]="newsLink.DataElement">{{newsLink.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="newsLink.External && !newsLink.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a></li>            </ul>
          </div>
          <h3 class="footer-heading-title">
            <span *ngIf="!homePageHeaderFooter">Vivere il Comune</span><span *ngIf="homePageHeaderFooter"><a [title]="'Vai alla pagina: Vivere Enna'" class="text-decoration-none" [attr.href]="homePageHeaderFooter.BaseURLSito + '/' + homePageHeaderFooter.Footer.TownLink">Vivere Enna</a></span> </h3>
          <div class="menu-vivere-il-comune-container">
            <ul id="menu-vivere-il-comune" class="footer-list" *ngIf="!homePageHeaderFooter">
              <li><a [href]="configurazione.baseUrl + '/vivere-il-comune/luoghi'">Luoghi</a></li>
              <li><a [href]="configurazione.baseUrl + '/vivere-il-comune/eventi'">Eventi</a></li>
            </ul>
            <ul id="menu-vivere-il-comune-api" class="footer-list" *ngIf="homePageHeaderFooter">
              <li *ngFor="let townLink of homePageHeaderFooter.Footer.Town"><a [title]="'Vai alla pagina: ' + townLink.Label" [attr.href]="townLink.External ? townLink.Link :  homePageHeaderFooter.BaseURLSito + '/' + townLink.Link"
                                                                               [attr.data-element]="townLink.DataElement">{{townLink.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="townLink.External && !townLink.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-9 mt-md-4 footer-items-wrapper">
          <h3 class="footer-heading-title"><span *ngIf="homePageHeaderFooter">{{homePageHeaderFooter.Footer.Contacts.Title}}</span><span *ngIf="!homePageHeaderFooter">Contatti</span></h3>
          <div class="row" *ngIf="!homePageHeaderFooter">
            <div class="col-md-4">
              <p class="footer-info">
                <strong>Comune di <span>{{configurazione ? configurazione.nome : ''}}</span></strong> <br><span>{{configurazione ? configurazione.indirizzo : ''}}</span><br>Codice fiscale / P.
                IVA:{{configurazione ? configurazione.cf : ''}} <br>PEC: <a style="font-weight: normal" [attr.href]="'mailto:' + (configurazione ? configurazione.email : '')" class="list-item">{{configurazione ? configurazione.email : ''}}</a>
                <br>Centralino unico: 0874 787131
                <br>
                <br>


              </p>
            </div>
            <div class="col-md-4">
              <div class="menu-info-1-container">
                <ul id="menu-info-1" class="footer-list">
                  <li><a [href]="configurazione.baseUrl + '/domande-frequenti/'" data-element="faq">Leggi le FAQ</a></li>
                  <li><a [href]="configurazione.linkAppuntamenti">Prenotazione appuntamento</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi/assistenza/'">Richiesta assistenza</a></li>
                  <li><a [href]="configurazione.baseUrl + '/servizi/segnalazione-disservizio/'" data-element="report-inefficiency">Segnalazione disservizio</a></li>
                  <li><a [href]="configurazione.baseUrl + '/meccanismo-di-feedback/'" data-element="report-inefficiency">Meccanismo di feedback</a></li>
                  <li><a [href]="configurazione.baseUrl + '/piano-di-miglioramento-del-sito/'" data-element="report-inefficiency">Piano di miglioramento del sito</a></li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <div class="menu-info-2-container">
                <ul id="menu-info-2" class="footer-list">
                  <li><a [href]="configurazione.linkAccessibilita" data-element="accessibility-link">Dichiarazione di accessibilità</a></li>
                  <li><a [href]="configurazione.linkTrasparenza">Amministrazione Trasparente</a></li>
                  <li><a [href]="configurazione.baseUrl + '/informativa-privacy/'" data-element="privacy-policy-link">Informativa privacy</a></li>
                  <li><a [href]="configurazione.baseUrl + '/note-legali/'" data-element="legal-notes">Note legali</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="homePageHeaderFooter">
            <div class="col-md-4">
              <p class="footer-info">
                <strong>{{homePageHeaderFooter.Footer.Contacts.City}}</strong> <br><span>{{homePageHeaderFooter.Footer.Contacts.Address}}</span><br>Codice fiscale / P.
                IVA:{{homePageHeaderFooter.Footer.Contacts.CfPiva}} <br>PEC: <a style="font-weight: normal" [attr.href]="'mailto:' + homePageHeaderFooter.Footer.Contacts.Pec" class="list-item">{{homePageHeaderFooter.Footer.Contacts.Pec}}</a>
                <br>Centralino unico: {{homePageHeaderFooter.Footer.Contacts.Tel}}
                <br>Cod Ipa: {{homePageHeaderFooter.Footer.Contacts.CodIpa}}
                <br>


              </p>
            </div>
            <div class="col-md-4">
              <div class="menu-info-1-container">
                <ul id="menu-info-1-api" class="footer-list">
                  <li *ngFor="let link1 of homePageHeaderFooter.Footer.Contacts.Links1"><a [title]="'Vai alla pagina: ' + link1.Label" [attr.href]="link1.External ? link1.Link :  homePageHeaderFooter.BaseURLSito + '/' + link1.Link"
                                                                                           [attr.data-element]="link1.DataElement">{{link1.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="link1.External && !link1.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <div class="menu-info-2-container">
                <ul id="menu-info-2-api" class="footer-list">
                  <li *ngFor="let link2 of homePageHeaderFooter.Footer.Contacts.Links2"><a [title]="'Vai alla pagina: ' + link2.Label" [attr.href]="link2.External ? link2.Link :  homePageHeaderFooter.BaseURLSito + '/' + link2.Link"
                                                                                           [attr.data-element]="link2.DataElement">{{link2.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="link2.External && !link2.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 mt-md-4 footer-items-wrapper">
          <h3 *ngIf="configurazione.flFacebook || configurazione.flInstagram || configurazione.flTwitter" class="footer-heading-title">Seguici su</h3>
          <ul class="list-inline text-start social" *ngIf="!homePageHeaderFooter">
            <li class="list-inline-item" *ngIf="configurazione.flFacebook">
              <a href="{{configurazione.linkFacebook}}" target="_blank" class="p-2 text-white">
                <svg class="icon icon-sm icon-white align-top"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="./content/svg/sprites.svg#it-facebook"></use>
                </svg>
                <span class="visually-hidden">Facebook</span>
              </a>
            </li>
            <li class="list-inline-item" *ngIf="configurazione.flInstagram">
              <a href="{{configurazione.linkInstagram}}" target="_blank" class="p-2 text-white">
                <svg class="icon icon-sm icon-white align-top"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="./content/svg/sprites.svg#it-instagram"></use>
                </svg>
                <span class="visually-hidden">Instagram</span>
              </a>
            </li>
            <li class="list-inline-item" *ngIf="configurazione.flTwitter">
              <a href="{{configurazione.linkTwitter}}" target="_blank" class="p-2 text-white">
                <svg class="icon icon-sm icon-white align-top"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="./content/svg/sprites.svg#it-whatsapp"></use>
                </svg>
                <span class="visually-hidden">Whatsapp</span>
              </a>
            </li>
          </ul>
          <ul class="list-inline text-start social" *ngIf="homePageHeaderFooter">
            <li class="list-inline-item" *ngFor="let social of homePageHeaderFooter.Footer.FollowOn">
              <a [attr.href]="social.Href" target="_blank" class="p-2 text-white">
                <svg class="icon icon-sm icon-white align-top"><use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.href]="'./content/svg/sprites.svg#' + social.Item"></use>
                </svg>
                <span class="visually-hidden">{{ social.Social }}</span>
              </a>
            </li>
          </ul>
          <!-- /header-social-wrapper -->
        </div>
      </div>
      <!--<section class="py-4 border-white border-top" *ngIf="configurazione">
        <div class="row">
          <div class="col-lg-3 col-md-3 pb-2">
            <h4>
              <a title="Amministrazione">Amministrazione trasparente</a>
            </h4>
            <p>
              I dati personali pubblicati sono riutilizzabili solo alle condizioni previste dalla direttiva comunitaria 2003/98/CE e dal
              d.lgs. 36/2006
            </p>
          </div>
          <div class="col-lg-3 col-md-3 pb-2">
            <h4>
              <a style="cursor: default" title="Contatti">Contatti</a>
            </h4>
            <p>
              <strong><span *ngIf="configurazione.nome">{{configurazione.nome | uppercase}}</span></strong><br />
              <span *ngIf="configurazione.indirizzo">{{configurazione.indirizzo}}</span> - <span *ngIf="configurazione.cap">{{configurazione.cap}}</span> <br>
              Codice fiscale / P. IVA: <span *ngIf="configurazione.cf">{{configurazione.cf}}</span>
            </p>
            <div class="link-list-wrapper">
              <ul class="footer-list link-list clearfix">
                <li *ngIf="configurazione.email">
                  <a class="list-item" [href]="'mailto:' + configurazione.email" title="Posta Elettronica Certificata">Posta Elettronica Certificata</a>
                </li>
                <li>
                  DA CHIEDERE
                  <a class="list-item" href="#" title="URP - Ufficio Relazioni con il Pubblico">URP - Ufficio Relazioni con il Pubblico</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 pb-2">
            <h4>
              <a *ngIf="configurazione?.flTwitter || configurazione?.flInstagram || configurazione?.flFacebook || configurazione?.flLinkedin || configurazione?.flYoutube">Seguici su</a>
            </h4>
            <ul class="list-inline text-start social">
              <li class="list-inline-item" *ngIf="configurazione?.flFacebook && configurazione.linkFacebook">
                <a class="p-2 text-white btn-primary primary-button" style="border-radius: 25%" [href]="configurazione.linkFacebook" target="_blank">
                  <svg class="icon icon-sm icon-white align-top"><use href="content/svg/sprites.svg#it-facebook"></use></svg>
                  <span class="visually-hidden">Facebook</span></a>
              </li>
              <li class="list-inline-item" *ngIf="configurazione?.flInstagram && configurazione.linkInstagram">
                <a class="p-2 text-white btn-primary primary-button" style="border-radius: 25%" [href]="configurazione.linkInstagram" target="_blank">
                  <svg class="icon icon-sm icon-white align-top"><use href="content/svg/sprites.svg#it-instagram"></use></svg>
                  <span class="visually-hidden">Instagram</span></a>
              </li>
              <li class="list-inline-item" *ngIf="configurazione?.flTwitter && configurazione.linkTwitter">
                <a class="p-2 text-white btn-primary primary-button" style="border-radius: 25%" [href]="configurazione.linkTwitter" target="_blank">
                  <svg class="icon icon-sm icon-white align-top"><use href="content/svg/sprites.svg#it-twitter"></use></svg>
                  <span class="visually-hidden">Twitter</span></a>
              </li>
              <li class="list-inline-item" *ngIf="configurazione?.flLinkedin && configurazione.linkLinkedin">
                <a class="p-2 text-white btn-primary primary-button" style="border-radius: 25%" [href]="configurazione.linkLinkedin" target="_blank" title="Apri sito esterno - Linkedin">
                  <svg class="icon icon-sm icon-white align-top"><use href="content/svg/sprites.svg#it-linkedin"></use></svg>
                  <span class="visually-hidden">Linkedin</span></a>
              </li>
              <li class="list-inline-item" *ngIf="configurazione?.flYoutube && configurazione.linkYoutube">
                <a class="p-2 text-white btn-primary primary-button" style="border-radius: 25%" [href]="configurazione.linkYoutube" target="_blank" title="Apri sito esterno - YouTube">
                  <svg class="icon icon-sm icon-white align-top"><use href="content/svg/sprites.svg#it-youtube"></use></svg>
                  <span class="visually-hidden">Youtube</span></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="d-flex justify-content-around align-items-center">
          <img src="content/images/footer/eu.png" width="102" height="68">
          <img src="content/images/footer/repubblica_italiana.png" width="73" height="83">
          <img src="content/images/footer/regione_siciliana.png" width="102" height="102">
          <img src="content/images/footer/fesr.png" width="253" height="110">
        </div>
      </section> -->
    </div>
    <div class="it-footer-small">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-sm-12 footer-items-wrapper">
            <div class="footer-bottom" *ngIf="!homePageHeaderFooter">
              <a style="font-weight: normal" href="javascript:void(0)">Mappa del sito</a>
            </div>
            <div class="footer-bottom" *ngIf="homePageHeaderFooter"><a [title]="'Vai alla pagina: ' + linkBottom.Label" style="font-weight: normal" *ngFor="let linkBottom of homePageHeaderFooter.Footer.Contacts.LinksBottom" [attr.href]="linkBottom.External ? linkBottom.Link :  homePageHeaderFooter.BaseURLSito + '/' + linkBottom.Link"
                                                                                       [attr.data-element]="linkBottom.DataElement">{{linkBottom.Label}}<svg class="icon icon-white icon-sm align-middle" *ngIf="linkBottom.External && !linkBottom.Link.includes('servizi-digitali')"><use href="content/svg/sprites.svg#it-external-link"></use></svg></a>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 footer-items-wrapper">
            <div class="footer-copyright">Sviluppo <a style="font-weight: normal"
                                                      href="https://www.datamanagementitalia.it/" target="_blank">Datamanagement
              Italia S.p.A.</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<a href="#" aria-hidden="true" tabindex="-1" data-attribute="back-to-top" class="back-to-top">
  <svg class="icon icon-light"></svg>
</a>

